export const documents = {
  termsOfService: {
    label: 'Terms of Service',
    src: '/docs/centourio-terms-of-service.pdf',
  },

  privacyPolicy: {
    label: 'Privacy Policy',
    src: '/docs/centourio-privacy-policy.pdf',
  },

  cookiePolicy: {
    label: 'Cookie Policy',
    src: '/docs/centourio-cookie-policy.pdf',
  },
};
